<template>
  <div
    v-if="explainStatus === 'explaining'"
    class="plv-iar-product__explain--explaining"
    :class="{
      'plv-iar-product__explain--explaining--no-cover': !cover,
      'plv-iar-product__explain--explaining--cover': cover,
      'plv-iar-product__explain--explaining--lang': lang === 'en',
    }"
  >
    <img class="plv-iar-product__explain--explaining__icon" src="./imgs/live.gif" />
    <span>{{ iarTrans('product.explaining') }}</span>
  </div>
  <div
    v-else-if="explainStatus === 'explained'"
    class="plv-iar-product__explain--explained"
    :class="{
      'plv-iar-product__explain--explained--cover': cover,
      'plv-iar-product__explain--explained--no-cover': !cover,
      'plv-iar-product__explain--explained--lang': lang === 'en',
    }"
    @click.stop="onClickExplain"
  >
    <img class="plv-iar-product__explain--explained__icon" src="./imgs/play.png" />
    <span>{{ iarTrans('product.watchExplain') }}</span>
  </div>
  <span
    v-else
    class="plv-iar-product__explain--not-explained"
    :class="{
      'pws-iar-product-list-not-explained': !cover,
      'plv-iar-product__explain--not-explained--no-cover': !cover,
      'plv-iar-product__explain--not-explained--cover': cover,
      'plv-iar-product__explain--not-explained--lang': lang === 'en',
    }"
  >{{ iarTrans('product.notExplained') }}</span>
</template>

<script>
import basicMixin from '../../../assets/mixins/basic';

export default {
  mixins: [basicMixin],

  inject: ['productVm'],

  props: {
    explainStatus: {
      type: String,
      default: '',
    },
    /** 有封面和无封面下，讲解状态的显示位置不一样 */
    cover: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
    };
  },

  methods: {
    onClickExplain() {
      this.$emit('click-explain');
    },
  },
};
</script>

<style lang="scss">
.plv-iar-product__explain--explaining {
  width: 100%;
  height: 20px;
  border-radius: 0 0 8px 8px;
  background: rgba(255, 98, 100, 0.8);
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  color: #FFFFFF;
  .plv-iar-product__explain--explaining__icon {
    width: 14px;
    height: 14px;
    margin-right: 2px;
    vertical-align: top;
  }
}

.plv-iar-product__explain--explaining--no-cover {
  border-radius: 2px;
  background: #FF5252;
  border: 1px solid rgba(255, 82, 82, 0.6);
  color: #FFFFFF;
  width: 52px;
  height: 16px;
  padding: 1px 2px;
  white-space: nowrap;
  font-size: 12px;
  transform: scale(0.8333);
}

.plv-iar-product__explain--explaining--lang {
  width: 80px;
}

.plv-iar-product__explain--explained {
  width: 66px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #FF6264;
  box-sizing: border-box;
  border-radius: 456px;
  background: #FFFFFF;
  cursor: pointer;
  white-space: nowrap;
  .plv-iar-product__explain--explained__icon {
    width: 12px;
    height: 12px;
    margin-right: 2px;
    vertical-align: top;
  }
}
.plv-iar-product__explain--explained--no-cover {
  width: 74px;
  height: 24px;
  padding: 3.5px 12px;
  font-size: 12px;
  color: #FF6264;
  border-radius: 16px;
  background: #FFEFEF;
  margin-right: 8px;
}

.plv-iar-product__explain--explained--lang {
  width: 92px;
}

.plv-iar-product__explain--not-explained {
  width: 52px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 500;
  color: #4E5969;
  border-radius: 456px;
  background: #FFFFFF;
  box-sizing: border-box;
}
.plv-iar-product__explain--not-explained--no-cover {
  height: 20px;
  border-radius: 2px;
  box-sizing: border-box;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  flex: none;
  margin: 0 2px;
  white-space: nowrap;
  color: unset;
  border-color: unset;
  background: transparent;
  font-size: 12px;
  transform: scale(0.833);
}

.plv-iar-product__explain--explaining--cover {
  position: absolute;
  bottom: 0;
  left: 0;
}
.plv-iar-product__explain--not-explained--cover,
.plv-iar-product__explain--explained--cover {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 8px;
}

.plv-iar-product__explain--not-explained--lang {
  width: 80px;
}
.plv-iar-product__explain--not-explained--no-cover.plv-iar-product__explain--not-explained--lang {
  width: 64px;
}
</style>
